module.exports = __webpack_public_path__ + "static/media/Service-red.70d9936c.svg";